import React from "react";
import { connect } from "react-redux";
import { Row, Col, Skeleton } from "antd";
import { withRouter } from "react-router";

import Sidebar from "components/sidebar/Sidebar";
import WindowStickyFooter from "components/WindowStickyFooter";
import ProgressIndicator from "./headers/ProgressIndicator";

class Workspace extends React.Component {
  render() {
    const { input } = this.props;
    return (
      <Row className="workspace">
        <Col md={24} lg={8}>
          <Sidebar />
        </Col>
        <Col md={24} lg={16}>
          <ProgressIndicator />
          {input ? (
            <WindowStickyFooter />
          ) : (
            <div className="form-container">
              <div className="padding">
                <Skeleton active />
              </div>
            </div>
          )}
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = store => {
  const { input } = store.inputReducer;
  return { input };
};

export default withRouter(connect(mapStateToProps)(Workspace));
